<script lang="ts">
  import { book } from "../../stores/WalkinBookingStore";
  import { step } from "../../stores/WalkinBookingStore";

  export let locations: any;
  export let location: string = "";

  let isOpen = false;

  let filteredLocations: any = [];

  let walkinsActiveLocations: string[] = [
    "atlanta",
    "long beach",
    "chicago (west loop)",
    "denver",
    "denver downtown",
    "colorado springs",
    "alexandria",
    "mississauga",
    "burlington",
    "charlotte",
    "dallas",
    "fresno",
    "indianapolis",
    "minneapolis (city center)",
    "oklahoma",
    "ottawa",
    "rochester",
    "surrey",
    "syracuse",
    "waterloo",
  ];

  const toggleDropdown = () => {
    isOpen = !isOpen;
  };

  const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target.closest(".custom-select")) {
      isOpen = false;
    }
  };

  $: selectedLocationName = location
    ? locations.find((loc: any) => String(loc.id) === location)?.name ||
      "Select a Location"
    : "Select a Location";

  const locationChange = (e: any) => {
    const newLocation = String(e.target.value);
    location = newLocation;
    isOpen = false;
    // Let the parent component handle the store update
    // This will ensure the reactive statement in WalkinBooking.svelte runs correctly
  };

  const onNextStep = () => {
    if (location != "") {
      step.update((value) => value + 1);
    }
  };

  const normalizeLocationName = (locationName: string) => {
    if (locationName.toLowerCase() === "denver downtown") {
      return "Denver";
    }

    return locationName;
  };

  $: if (locations) {
    filteredLocations = locations.filter((loc: any) =>
      walkinsActiveLocations.includes(loc.name.toLowerCase())
    );
  }

  $: {
    if (location != "") {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has("l")) {
        // URL has parameters, continue
        step.update((value) => value + 1);
      }
    }
  }
</script>

<svelte:window on:click={handleClickOutside} />

<div class="max-w-3xl w-full mx-auto relative mb-2">
  <div class="flex flex-col items-center justify-center mb-2">
    <h3
      class="text-lg font-semibold uppercase font-helveticaneue-bold-extended"
    >
      Select a location near you
    </h3>
    <p class="text-base text-gray-600">
      Select a city to find your nearest location
    </p>
  </div>
  <div class="mt-6">
    <div class="custom-select relative w-full">
      <div
        class="selected-value flex items-center justify-between px-4 py-4 border border-gray-300 rounded-lg cursor-pointer bg-white relative pl-6"
        on:click={toggleDropdown}
      >
        <span class="selected-text text-gray-700 w-full text-center uppercase">
          {normalizeLocationName(selectedLocationName)}
        </span>
        <svg
          class="w-4 h-4 text-gray-500 transform transition-transform {isOpen
            ? 'rotate-180'
            : ''}"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
      <ul
        class="options-list absolute w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto z-10 w-full text-center uppercase {isOpen
          ? ''
          : 'hidden'}"
      >
        {#if locations}
          {#each filteredLocations as loc}
            <li
              class="px-4 py-4 hover:bg-gray-100 cursor-pointer"
              data-value={String(loc.id)}
              on:click={() => {
                location = String(loc.id);
                locationChange({ target: { value: String(loc.id) } });
              }}
            >
              {normalizeLocationName(loc.name)}
            </li>
          {/each}
        {/if}
      </ul>
    </div>
    <select
      bind:value={location}
      class="w-full text-center rounded-lg hidden py-4"
      on:change={locationChange}
    >
      <option value="">Select a Location</option>
      {#if locations}
        {#each locations as loc}
          <option value={String(loc.id)}
            >{normalizeLocationName(loc.name)}</option
          >
        {/each}
      {/if}
    </select>
  </div>
  <div class="mt-6">
    <button
      on:click={onNextStep}
      class="w-full bg-black text-white px-4 py-2 rounded-lg text-2xl"
      >Next</button
    >
  </div>
</div>

<style></style>
